import React from 'react';
import styled from 'styled-components';

const Table = styled.table`
	margin: 20px 0;
	font-size: 1.4em;
	color: #707070;
	
	thead {
	 color: #B2B2B2;
	 
	 th {
	   border: 0;
	 }
	}
	
	th i {
	 	font-size: 1.6em;
    	margin-right: 7px;
	}
	
	th, td {
	   vertical-align: middle;
	}
	
	tr td {
	 button.btn-danger {
	     background-color: #FF003C;
	     border-color: #FF003C;
	     font-size: 1em;
	     padding: 8px 20px;
	     color: #707070;
	     
	     &:hover {
	       background: #ffffff;
	       color: #FF003C;
	     }
	 }
	 
	 button.btn-simple {
	     background-color: #707070;
	     border-color: #707070;
	     font-size: 1em;
	     padding: 8px 20px;
	     color: #ffffff;
	     
	     &:hover {
	       background: #ffffff;
	       color: #707070;
	     }
	 }
	}	
`;

const btnClickAction = (e, button, row) => {
	if (typeof button.onClick === 'function') {
		button.onClick(row);
	}
};

const TableList = (props) => {
	const { dataThead, dataTbody, button } = props;

	function textDefault() {
		return (
			<span className="pl-1">- - - -</span>
		);
	}

	return (
		<div className="table-responsive">
			<Table className="table">
				<thead>
					{dataTbody.length === 0 ? 'Nenhum cliente encontrado!' : (
						<tr>
							{ dataThead.map(data => (
								<th scope="col">{ data }</th>
							))}
						</tr>
					)}
				</thead>

				<tbody>
					{
						dataTbody.map(briefing => (
							<tr key={briefing.id ? briefing.id : Math.random()}>
								<td>
									{
										briefing.attributes.company_name
											? briefing.attributes.company_name
											: textDefault()
									}
								</td>

								<td>
									{
										briefing.attributes.document_number
											? briefing.attributes.document_number
											: textDefault()
									}
								</td>

								<td>
									{
										briefing.attributes.webmotors_id
											? briefing.attributes.webmotors_id
											: textDefault()
									}
								</td>
								<td>
									<a href={`/backoffice/cliente/${briefing.id}/editar`} onClick={e => btnClickAction(e, button, briefing)} className={`btn ${button.classButton} float-right`}>{button.value}</a>
								</td>
							</tr>
						))
					}
				</tbody>
			</Table>
		</div>
	);
};

export default TableList;
